import { PartnerLogoProps } from "@ctypes";
import { resolveLogoSize } from "@utils/logo";

const WIDTH = 634.939;
const HEIGHT = 491.181;

export const ArmstrongWatermark = ({ className, style, width, height }: PartnerLogoProps) => {
  const size = resolveLogoSize({ width, height, naturalWidth: WIDTH, naturalHeight: HEIGHT });

  return (
    <svg
      width={size.width}
      height={size.height}
      viewBox="0 0 634.939 491.181"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
      style={style}
    >
      <g id="Layer 1">
      <path id="Vector" d="M194.383 491.181H0L220.304 0H414.687L194.383 491.181Z" fill="white"/>
      <path id="Vector_2" d="M351.921 139.934L317.494 216.715L440.556 491.181H509.411L351.921 139.934ZM414.685 0L380.258 76.7817L566.085 491.181H634.939L414.685 0Z" fill="white" fillOpacity="0.31"/>
      </g>
    </svg>
  );
};
